module.exports = __webpack_public_path__ + "img/hb.41e37580.png";